import { sortBy } from "lodash";

export const usePerformAssessments = () => {

    const handleClick = (assessments_to_perform_ids) => {
        const disabled = !assessments_to_perform_ids.length

        if (disabled) return
        const sortedAssessments = sortBy(assessments_to_perform_ids)

        return sortedAssessments
    }

    return handleClick
}

export default usePerformAssessments